import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWazeComponent } from './simple-icons-waze.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWazeComponent ],
    exports:      [ SimpleIconsWazeComponent ],
    bootstrap:    []
})
export class SimpleIconsWazeModule {}
